<mat-card class="row  box-shadow">
  <mat-card-header class="col-12">
    <mat-card-title class="col-12">
      <ng-template [ngIf]="isCurrentBook" [ngIfElse]="noCurrent">
        <h3>Ma réservation en cours</h3>
      </ng-template>
      <ng-template #noCurrent>
        <h3>Ma prochaine réservation</h3>
      </ng-template>

    </mat-card-title>
  </mat-card-header>
  <ng-template [ngIf]="bookList == null  && station == null" [ngIfElse]="loaded">
    <mat-card-content>
    </mat-card-content>
  </ng-template>
  <ng-template #loaded>

    <mat-card-content>
      <ng-template [ngIf]="book == null" [ngIfElse]="nextBook">
        <h4>Aucune réservation trouvée</h4>
      </ng-template>
      <ng-template #nextBook>
          <div class="col-12">
              <div>
                <app-book-info-block [book]="book"></app-book-info-block>
              </div>
            </div>
        <!-- <div class="col-12">

          <div class="row justify-content-center">
            <mat-toolbar class="col-8" color="primary">
              <mat-toolbar-row>
                <h5 class="col-12 ">
                  {{book.key}}
                </h5>
              </mat-toolbar-row>
            </mat-toolbar>
            <h4 class="col-12">
              <mat-icon aria-hidden="false" aria-label="Example home icon">place</mat-icon>
              {{_station.name}}
            </h4>
            <label class="col-12">
              Adresse : {{station.street}} {{station.city}}
            </label>
            <div class="col-12">
              <div class="row reservation-day">
                <div class="col-6">
                  <label>
                    <mat-icon aria-hidden="false" aria-label="Example home icon">today</mat-icon>
                    Début de reservation
                  </label>
                </div>
                <div class="col-6 end">
                  <label class="">
                    <mat-icon aria-hidden="false" aria-label="Example home icon">today</mat-icon>
                    Fin de reservation
                  </label>
                </div>
              </div>
            </div>
            <hr>
            <div class="col-12 marge">
              <div class="row">
                <div class="col-5">
                  <label>
                    {{start | date:"dd/MM/yyyy HH:mm"}}
                  </label>
                </div>
                <div class="col-2 mid">
                  <mat-icon aria-hidden="false" aria-label="Example home icon">trending_flat</mat-icon>
                </div>
                <div class="col-5 end">
                  <label>
                    {{end | date:"dd/MM/yyyy HH:mm"}}
                  </label>
                </div>
              </div>
            </div>

            <div class="col-sm-6 ">
              <label class="row">
                <mat-icon aria-hidden="false" aria-label="Example home icon">credit_card</mat-icon>
                Prix de la réservation : {{book.price}} €
              </label>
            </div>
            <div class="col-sm-6 end">
              <label class="row" class="{{book.status}}" *ngIf="book.status == 'reserved'">
                status : réservée
              </label>
              <label class="row" class="{{book.status}}" *ngIf="book.status == 'completed'">
                status : terminée
              </label>
              <label class="row" class="{{book.status}}" *ngIf="book.status == 'canceled'">
                status : annulée
              </label>
            </div>
          </div>
        </div> -->
      </ng-template>
      <!-- <mat-card-actions>
        <div class="col-12">
            <ng-template [ngIf]="book == null" [ngIfElse]="nextBook">
              </ng-template>
              <ng-template #nextBook>
          <div class="row  justify-content-around">
            <ng-template [ngIf]="isCurrentBook" [ngIfElse]="noCurrentAction">
              
              <a class="col-sm-3 col-8" routerLink="/auth/reservation/{{book.id}}">

                <button class="full-width" mat-flat-button disabled color="warn">Annuler</button>
              </a>
            </ng-template>
            <ng-template #noCurrentAction>
              <a class="col-sm-3 col-8" routerLink="/auth/reservation/{{book.id}}">

                <button class="full-width" (click)="openCancelConfirm()" mat-flat-button color="warn">Annuler</button>
              </a>
            </ng-template>
            <a class="col-sm-3 col-8" routerLink="/auth/reservation/{{book.id}}">
              <button class="full-width" disabled mat-stroked-button>Partager</button>
            </a>
            <a class="col-sm-3 col-8" routerLink="/auth/reservation/{{book.id}}">
              <button class="full-width" mat-flat-button color="primary">Prolonger</button>
            </a>
          </div>
          </ng-template>
        </div>
      </mat-card-actions> -->
    </mat-card-content>

  </ng-template>
  <div class="row loading-block">
    <ng-template [ngIf]="bookList == undefined">
      <mat-progress-bar class="col-12" mode="indeterminate" color='primary'></mat-progress-bar>
    </ng-template>
  </div>
</mat-card>
